import styled from 'styled-components'

import { ProductListItem } from '../../../shared/api/generated'
import { NoProducts } from '../../../shared/ui-kit/actual/NoProducts'
import { ProductCardsList } from '../../../shared/ui-kit/actual/ProductCardsList'
import type { ProductListCardVariant } from '../../../shared/ui-kit/actual/ProductListCard'
import { PageLoader } from '../../../shared/ui-kit/deprecated/PageLoader'
import { FlexColumn, FlexRow, StyledLinkPrimary } from '../../../shared/ui-kit/projectComponents'

const GoodsWrapper = styled.div`
  width: 100%;
  max-width: 1280px;
  margin-inline: auto;
`

type GoodsListProps = {
  brandImage?: string
  goods?: any
  iconSrc?: string
  isArchive?: boolean
  isLoading?: boolean
  items?: ProductListItem[]
  messageNoProducts: string
  notYourList?: boolean
  variant?: ProductListCardVariant
}
export const GoodsDesktopList = ({
  brandImage,
  goods,
  iconSrc,
  isArchive,
  isLoading,
  items,
  messageNoProducts,
  notYourList,
  variant,
}: GoodsListProps) => {
  return (
    <GoodsWrapper>
      {isLoading ? (
        <FlexRow style={{ width: '100%' }}>
          <PageLoader />
        </FlexRow>
      ) : (
        <>
          {items?.length ? (
            <ProductCardsList
              badgeImageUrl={brandImage || iconSrc}
              getProductHref={item => `${isArchive ? '/archive-item/' : '/item/'}${item.productId}`}
              products={items}
              variant={variant}
            />
          ) : (
            <FlexColumn>
              <NoProducts imgPath={'/images/interface/EmptyBag.svg'} message={messageNoProducts} />
              {!notYourList && (
                <StyledLinkPrimary
                  style={{ marginBottom: '54px', whiteSpace: 'nowrap', width: 'auto' }}
                  to={'/add'}
                >
                  Добавить объявление
                </StyledLinkPrimary>
              )}
            </FlexColumn>
          )}
        </>
      )}
    </GoodsWrapper>
  )
}
